export const expandFontTheme = (params) => {
    const { font = 'inherit', textTransform = 'inherit' } = params || {};
    return `
  font: ${font};
  text-transform: ${textTransform};
`;
};
